<!-- <div
  echarts
  class="echarts mt-1 mb-0 pb-0"
  [options]="option"
  (chartClick)="onChartClick($event, templateallpdf)"
  style="height: 200px; width: 100%"
></div>

 
<div class="table-responsive mt-0 pt-0" *ngIf="gaugeArray?.partwise_info?.length > 0 && partcountType === 'edge' && role !== 'SUPERUSER'">
  <p class="text-muted small mb-1">
    <i class="mdi mdi-information-outline me-1"></i>
    <em  style="color: red;">Note: Part details are derived from AOI file systems.</em>
  </p>
  <div class="table-responsive mt-0" *ngIf="consolidatedTableData.length > 0">
  <table class="table table-bordered table-sm text-center align-middle">
    <thead class="table-dark">
      <tr>
        <th>#</th>
        <th>Part Name</th>
        <th>Side</th>
        <th>Total Part</th>
        <th>Pass</th>
        <th>Fail</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of consolidatedTableData; let i = index">
        <td>{{ i + 1 }}</td>
        <td>
        <strong>{{ row.programName.substring(0, row.programName.lastIndexOf('-')) }}</strong>
        </td>
        <td>
        <strong>{{ getOperationLabel(row.programName) }}</strong>
        </td>
        <td>
          {{ row.partProduced }}
        </td>
        <td> 
            {{ row.partProduced - row.partRejected }}
        </td>
        <td>
            {{ row.partRejected }}
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div *ngIf="consolidatedTableData.length == 0">
  <p class="text-muted small mb-1">
    <em>No Data Available</em>
  </p>
</div>
</div>

<ng-template #templateallpdf role="document" let-modal="close">
  <div class="modal-header">
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body">
    <div
      *ngIf="partBreakdownOption"
      echarts
      [options]="partBreakdownOption"
      class="chart-container"
      style="height: 350px; width: 100%"
    ></div>
  </div>
</ng-template> -->
<div
  echarts
  class="echarts mt-1 mb-0 pb-0"
  [options]="option"
  (chartClick)="onChartClick($event, templateallpdf)"
  style="height: 200px; width: 100%"
></div>

<!-- Part Summary Table -->
<div
  class="mt-0 pt-0"
  *ngIf="
    gaugeArray?.partwise_info?.length > 0 &&
    partcountType === 'edge' &&
    role !== 'SUPERUSER'
  "
>
  <!-- Note -->
  <p class="small mb-2" style="color: #c0392b">
    <i class="mdi mdi-information-outline me-1"></i>
    <em>Note: Part details are derived from AOI file systems.</em>
  </p>

  <!-- Table -->
  <div class="table-responsive" *ngIf="consolidatedTableData.length > 0">
    <table class="table table-bordered table-sm text-center align-middle mb-1">
      <thead class="table-dark">
        <tr>
          <th style="width: 40px">#</th>
          <th class="text-start">Part name</th>
          <th style="width: 80px">Side</th>
          <th style="width: 80px">Total</th>
          <th style="width: 80px">Pass</th>
          <th style="width: 80px">Fail</th>
        </tr>
      </thead>

      <tbody>
        <ng-container
          *ngFor="let row of consolidatedTableData; let i = index"
        >
          <!-- ── Main Row ── -->
          <tr
            (click)="toggleRow(i)"
            style="cursor: pointer"
            [class.table-active]="isExpanded(i)"
          >
            <td>
              <span
                class="me-1"
                style="
                  font-size: 10px;
                  color: #888;
                  display: inline-block;
                  transition: transform 0.2s;
                "
                [style.transform]="
                  isExpanded(i) ? 'rotate(90deg)' : 'rotate(0deg)'
                "
                >&#9658;</span
              >
              {{ i + 1 }}
            </td>
            <td class="text-start">
              <!-- row.programName.substring(0, row.programName.lastIndexOf("-")) -->
              <strong>{{
                row.programName
              }}</strong>
            </td>
            <td>
              
                {{ getOperationLabel(row.programName) }}
            
            </td>
            <td>
              <strong>{{ row.partProduced }}</strong>
            </td>
            <td>
              {{
                row.partProduced - row.partRejected
              }}
            </td>
            <td>
            
                {{ row.partRejected }}
             
            </td>
          </tr>

          <tr *ngIf="isExpanded(i)">
            <td colspan="6" class="p-0 border-0">
              <div>
                
                <ng-container
                  *ngIf="
                    row.rejectedPartIds && row.rejectedPartIds.length > 0;
                    else noRejections
                  "
                >
                  <table
                    class="table table-sm mb-0"
                    style="font-size: 11px; background: transparent"
                  >
                    <thead class="table-dark">
                      <tr>
                        <th class="text-start ps-2" style="width: 35%">
                          Part ID
                        </th>
                        <th class="text-start" style="width: 45%">
                          Part name
                        </th>
                        <th class="text-center" style="width: 20%">Inspection End Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let rej of row.rejectedPartIds">
                        <td
                          class="text-start ps-2"
                          style="
                            font-family: monospace;
                            font-size: 14px;
                            max-width: 0;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                          "
                          [title]="rej._id"
                        >
                          {{ rej._id }}
                        </td>
                        <td
                          class="text-start"
                          style="
                            font-size: 14px;
                            max-width: 0;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                          "
                          [title]="rej.partName"
                        >
                          {{ rej.partName || "-" }}
                        </td>
                        <td class="text-center" style="font-size: 14px">
                          {{ rej.time || "-" }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </ng-container>
                <ng-template #noRejections>
                  <p
                    class="text-muted small text-center py-2 mb-0"
                    style="font-size: 11px"
                  >
                    <i class="mdi mdi-check-circle-outline me-1 text-success"></i>
                    <em>No rejections recorded for this part</em>
                  </p>
                </ng-template>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>


    </table>

    <p class="text-muted mb-0" style="font-size: 10px; text-align: right">
      <i class="mdi mdi-gesture-tap me-1"></i>Click any row to view rejection
      details
    </p>
  </div>

  <!-- Empty State -->
  <div *ngIf="consolidatedTableData.length === 0">
    <p class="text-muted small mb-1"><em>No data available</em></p>
  </div>
</div>

<!-- PIN Breakdown Modal -->
<ng-template #templateallpdf role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Part Breakdown</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body">
    <div
      *ngIf="partBreakdownOption"
      echarts
      [options]="partBreakdownOption"
      class="chart-container"
      style="height: 350px; width: 100%"
    ></div>
  </div>
</ng-template>